import SideNavbar from "./side-navbar/side-navbar.tsx";
import { Header } from "./header/header.tsx";
import { Outlet, useLocation } from "react-router-dom";
import { BreadcrumbProvider } from "../../context/breadcrumb/breadcrumb-context.tsx";
import { getPerformanceLensPageName } from "../../lib/performance-lens/workspace-navigation.ts";

export const DashboardLayout = ({ menu, pageMeta }: any) => {
  const { pathname, search } = useLocation();
  const personalView = pathname === "/dashboard/myPerformance" ? new URLSearchParams(search).get("view") : null;
  const personalPageMeta = pathname === "/dashboard/myPerformance"
    ? personalView === "self" ? { title: "Self Check", description: "Reflect on your work each feedback cycle." }
      : personalView === "results" ? { title: "Feedback Received", description: "View your published feedback." }
        : { title: "Give feedback", description: "Review your teammates each feedback cycle." }
    : null;
  const performancePageName = getPerformanceLensPageName(menu, pathname, search);

  return (
    <BreadcrumbProvider>
      <div className="layout">
        <SideNavbar menu={menu} />
        <div className="main-layout">
          <Header title={performancePageName ?? personalPageMeta?.title ?? pageMeta.title} description={personalPageMeta?.description ?? pageMeta.description} isHome={pageMeta.isHome} />
          <main className="main"><Outlet /></main>
        </div>
      </div>
    </BreadcrumbProvider>
  );
};
